module.exports = __webpack_public_path__ + "static/media/22ESCWA9.0d757e23.jpg";